import React from "react";
import { ArrowRight, Check, Play } from "lucide-react";
import { Link } from "react-router-dom";
import { CarBadges } from "./CarBadges";

export default function CarCard({ car }) {
  return (
    <Link to={`/auto/${car.handle}`} className="group flex flex-col">
      <div className="relative block overflow-hidden rounded-[18px] border border-[var(--cm-line)] bg-white text-left">
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={car.image}
            alt={car.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute left-3 top-3 flex gap-2">
            <span className="flex items-center gap-1.5 rounded-md bg-white/95 px-2 py-1 font-mono-cm text-[0.6rem] uppercase tracking-[0.12em] backdrop-blur">
              <span className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[var(--cm-green)] opacity-75" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[var(--cm-green)]" />
              </span>
              Disponibile
            </span>
            {car.verified && (
              <span className="flex items-center gap-1 rounded-md bg-white/95 px-2 py-1 font-mono-cm text-[0.6rem] uppercase tracking-[0.12em] backdrop-blur">
                <Check size={11} className="text-[var(--cm-green)]" strokeWidth={3} />
                Verificata
              </span>
            )}
          </div>
          <span className="absolute bottom-3 right-3 rounded-md bg-black/55 px-2 py-1 font-mono-cm text-[0.6rem] uppercase tracking-[0.12em] text-white backdrop-blur">
            {car.photos} foto
          </span>
          {car.has_video && (
            <span className="absolute bottom-3 left-3 flex items-center gap-1.5 rounded-md bg-black/55 px-2 py-1 font-mono-cm text-[0.6rem] uppercase tracking-[0.12em] text-white backdrop-blur" data-testid="card-video-badge">
              <span className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-red-500" />
              </span>
              <Play size={10} className="fill-white text-white" /> Video
            </span>
          )}
        </div>
      </div>

      <div className="mt-4 flex items-start justify-between gap-3">
        <h3 className="text-[1.05rem] font-semibold leading-tight">
          {car.brand}{" "}
          <span className="font-normal text-[#6f6f68]">{car.trim}</span>
        </h3>
        <div className="text-right">
          <p className="whitespace-nowrap text-[1.05rem] font-semibold">
            {car.price}
          </p>
          {car.oldPrice && (
            <p className="text-[0.8rem] text-[#a0a098] line-through">
              {car.oldPrice}
            </p>
          )}
        </div>
      </div>

      <CarBadges car={car} />

      {car.specline && (
        <p className="mt-2 font-mono-cm text-[0.68rem] uppercase tracking-[0.1em] text-[#8a8a82]">
          {car.specline.split(" · ").filter((p) => p !== car.fuel).join(" · ")}
        </p>
      )}

      <span className="mt-4 inline-flex items-center gap-2 self-start text-[0.9rem] font-medium transition-all duration-200 group-hover:gap-3">
        Scopri cosa c'è dietro
        <ArrowRight size={16} />
      </span>
    </Link>
  );
}
